import { Button } from '@/components/Button'
import styles from './Success.module.css'
import { links } from '@/utils/link'
import { byDesign } from '@/infra/design'
import logoTaxfyleBlueUrl from '@/assets/misc/logo_taxfyle-blue.svg'
import imgManageBillingUrl from '@/assets/misc/img_manage-billing.svg'
import MakeDepositIllustration from '@/components/SpotIllustration/MakeDepositIllustration'

export function CheckoutSuccess() {
  return (
    <div className={styles.root}>
      <div className={styles.logo}>
        <img src={logoTaxfyleBlueUrl} alt="taxfyle logo." />
      </div>

      <div className={styles.content}>
        {byDesign(
          <img
            className={styles.illustration}
            src={imgManageBillingUrl}
            alt="Two hands exchanging a coin"
          />,
          <MakeDepositIllustration
            className={styles.illustration}
            label="Two hands exchanging a coin"
          />,
        )}
        <div className={styles.title}>
          Thank you! The payment has been successfully processed!
        </div>
        <div className={styles.description}>
          You can check the job status on the dashboard. If you have any
          questions, please reach out to our support team.
        </div>
        <div>
          <Button label="Go to Dashboard" to={links.jobs()} variant="primary" />
        </div>
      </div>
    </div>
  )
}
